import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import moment from 'moment';
import { Link } from 'react-router';
import ReactTable from 'react-table';
import { Panel, Button } from 'react-bootstrap';
import { GridTable, GridRow, GridHeaders } from '../ui/table';
import { ClientsOptions, JNAuthWarning } from 'components';
import { tableColumnsBuilder } from './utils';
import { getMapInstance } from 'utils';
import DatetimeRangePicker from 'react-bootstrap-datetimerangepicker';

class ClientsListView extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'Clients Table';

    this.filter_update_valid = true;
    this.filter_timer_id = null;

    this.linkCell = this.linkCell.bind(this);
    this.dateCell = this.dateCell.bind(this);
    this.booleanCell = this.booleanCell.bind(this);
    this.impactProperties = this.impactProperties.bind(this);
    this.handleSortingChange = this.handleSortingChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.filterRender = this.filterRender.bind(this);
    this.dateFilterRender = this.dateFilterRender.bind(this);
    this.handleApplyDate = this.handleApplyDate.bind(this);
    this.handleClearDate = this.handleClearDate.bind(this);
    this.handleFilterChanged = this.handleFilterChanged.bind(this);
  }

  linkCell({ row, value }) {
    const { pathname } = this.props.routing.locationBeforeTransitions;
    const { clients_table_list } = this.props;

    if(!value)
      value = '(none)';
    if(!value.replace(' ',''))
      value = '(none)';

    if(/^clients\/map/.test(pathname)) {
      return (
        <a
          className='clients-list-view-client-link'
          onClick={() => this.props.zoomToClient(row._id)}
          >
          <i className='fa fa-user'></i> {value}
        </a>
      );
    }
    else {
      return <Link to={`/client/${row._id}`}><i className='fa fa-user'></i> {value}</Link>
    }
  }
  dateCell({ row, value }) {
    if(!value) {
      return <div />
    }
    return <span>{moment(value).format('MMM DD, YYYY')}</span>
  }
  booleanCell({ value }) {
    return (
      <div
        title={!value ? `Your address may be invalid.` : `Your address is geocoded.`}
        className={`text-center text-${value ? 'primary' : 'warning'}`}
        >
        <i className={`fa fa-${value ? 'check-square' : 'square-o'} fa-2x`} />
      </div>
    )
  }
  impactProperties({ value, row, rowValues }) {
    if(value) {
      const { description, max_hail_size, max_house_count, max_wind_speet } = row.last_impact_report.map_properties;
      return (
        <div>
          {description && description != '' ? <h5>{description}</h5> : null}
          {max_hail_size != null ? <p>Max Hail Size : {max_hail_size}</p> : null}
          {max_house_count != null ? <p>Max House Count : {max_house_count}</p> : null}
        </div>
      )
      return <div>{hailSize ? `${hailSize} '' Hail` : ''}{name ? ` ${name}` : ''}</div>
    }
    else {
      return <div>N/A</div>
    }
  }
  handleSortingChange({ id }) {
    this.props.setClientSortColumn(this.props.sort_column == id ? `-${id}` : id);
  }
  handlePageChange(idx) {
    if(idx > this.props.offset) {
      this.props.fetchNextClients();
    }
    else {
      this.props.fetchPrevClients();
    }
  }
  handlePageSizeChange(size, offset) {
    if(this.props.handlePageSizeChange !== undefined) {
      this.props.handlePageChange(size, offset);
    }
    else {
      localStorage ? localStorage.setItem('clients_table_page_size', String(size)) : null;
      this.props.updateTablePageSize(size);
    }
  }
  filterRender({ column, onFilterChange}) {
    const { id } = column;
    const { filters } = this.props;
    const current_filter = filters.find(f => f.type == id);
    return (
      <input
        style={{ width: '90%' }}
        onChange={e => onFilterChange(e.target.value)}
        value={current_filter ? current_filter.value || '' : ''}
      />
    );
  }
  dateFilterRender() {
    const impact_report_filter = this.props.filters.find(f => f.type == 'last_impact_report.map_properties.storm_date');
    const { clients_table_open_state } = this.props;

    let
      start_date,
      end_date,
      f_start_date,
      f_end_date;
    if(impact_report_filter && impact_report_filter.value) {
      start_date = impact_report_filter.value.start_date ? moment(impact_report_filter.value.start_date) : moment().subtract(29, 'days');
      end_date = impact_report_filter.value.end_date ? moment(impact_report_filter.value.end_date) : moment();
      f_start_date = start_date.format('MM-DD-YYYY');
      f_end_date = end_date.format('MM-DD-YYYY');
    }
    else {
      start_date = moment().subtract(29, 'days');
      end_date = moment();
      f_start_date = null;
      f_end_date = null;
    }

    let label;
    if(f_start_date != null) {
      label = f_start_date == f_end_date ? f_start_date : `${f_start_date} - ${f_end_date}`;
    }
    else {
      label = 'Click to Select Date';
    }
    return (
      <div className='input-group'>
        <DatetimeRangePicker
          startDate={start_date}
          endDate={end_date}
          onApply={(e, picker) => this.handleApplyDate(picker)}
          drops={clients_table_open_state == 'half_open' ? 'up' : 'down'}
          >
          <input type='text' className='form-control' value={label}/>
        </DatetimeRangePicker>
        <span className='input-group-btn'>
          <Button
            className='default date-range-clear'
            onClick={this.handleClearDate}
            >
            <i className='fa fa-times'/>
          </Button>
        </span>
      </div>
    )
  }
  handleApplyDate({ startDate, endDate }) {
    this.handleFilterChanged(
      { id: 'last_impact_report.map_properties.storm_date' },
      { start_date: startDate.toISOString(), end_date: endDate.toISOString()}
    )
  }
  handleClearDate() {
    this.handleFilterChanged({ id: 'last_impact_report.map_properties.storm_date' }, null);
  }
  handleFilterChanged(column, input) {
    this.props.updateClientsFilters({ column_id: column.id, input });
  }
  componentWillMount() {
    const { pathname } = this.props.routing.locationBeforeTransitions;
    const { filters } = this.props;
    if(/^clients\/map/.test(pathname)) {
      this.props.fetchClients({ offset: 0, filters });
    }
    else {
      const size = localStorage ? localStorage.getItem('clients_table_page_size') || 10 : 10;
      this.props.fetchClients({ size, offset: 0, filters });
    }
  }
  componentDidUpdate(prev_props) {
    const prev_path = prev_props.routing.locationBeforeTransitions.pathname;
    const curr_path = this.props.routing.locationBeforeTransitions.pathname;
    if(/^clients\/map/.test(prev_path) && !/^clients\/map/.test(curr_path)) {
      $('.-pageSizeOptions').css({ display: 'inline-block' });
    }
    else if(!/^clients\/map/.test(prev_path) && /^clients\/map/.test(curr_path)) {
      $('.-pageSizeOptions').css({ display: 'none' });
    }
  }

  render() {
    const {
      selected_columns,
      fields,
      clients_table_list,
      fetching_clients,
      total,
      offset,
      size
    } = this.props;
    if(!clients_table_list)
      return <div></div>;

    const sort = this.props.sort_column.split(' ').map(item => {
      const desc = item[0] == '-';
      const id = desc? item.slice(1,item.length) : item;
      return { id, desc };
    });

    const { pathname } = this.props.routing.locationBeforeTransitions;

    return (
      <div>
        <JNAuthWarning />
        <div className='row'>
          <div className='col-xs-12 col-md-12'>
            <div className='pull-right'>
              <div className='clients-list-options-button-container'>
                <ClientsOptions
                  pull_right={true}
                  show_impact_report_download={false}
                  show_storm_date_picker={false}
                  show_name_filter={false}
                  title={'Options'}
                />
              </div>
            </div>
          </div>
        </div>
        <Panel>
          <div className='clients-table-container'>
            <ReactTable
              manual
              showFilters
              onFilteringChange={this.handleFilterChanged}
              data={clients_table_list}
              loading={fetching_clients}
              page={offset}
              sorting={sort}
              pages={Math.ceil(total / size)}
              onSortingChange={this.handleSortingChange}
              onPageChange={this.handlePageChange}
              onPageSizeChange={this.handlePageSizeChange}
              pageSize={this.props.page_size || size}
              pageSizeOptions={this.props.page_size_options || [ 5, 10, 20, 25, 50, 100 ]}
              columns={tableColumnsBuilder(
                this.filterRender, this.impactProperties, this.booleanCell,
                this.linkCell, this.dateFilterRender, this.dateCell,
                this.props.fields, this.props.selected_columns)
              }
            />
          </div>
        </Panel>
      </div>
    )
  }
}

ClientsListView.propTypes = {
  clients : PropTypes.object
}

const mapStateToProps = ({
  fields,
  routing,
  integrations: { jobnimbus_auth_error },
  clients : {
    total,
    offset,
    size,
    clients_table_list,
    fetching_clients,
    sort_column,
    selected_columns,
    filters,
    clients_table_open_state
  }
}) => ({
  fields : fields.Client || [],
  routing,
  jobnimbus_auth_error,
  total,
  offset,
  size,
  clients_table_list,
  fetching_clients,
  sort_column,
  selected_columns,
  filters,
  clients_table_open_state
});

export default connect(mapStateToProps, Actions)(ClientsListView);



// WEBPACK FOOTER //
// ./src/browser/components/clients/clients-list-view.js